//dependencias
import React from "react";
import { Route, Switch } from "react-router-dom";

//componentes
import ExpedienteNotas from "./components/expedienteNotas";
import Boletin from "./components/boletin";
import ConsultarNotas from "./components/consultarNotas";
import ReporteP from "./components/reportePlanificacion";
import SubirTareas from "./components/subirTareas";
import CxC from "./components/cpc";
import Pago from "./components/reportarPago/";
import Inicio from "./components/Inicio";
import Login from "./components/Login";
import Pagina404 from "./components/Pagina404";
import Chat from "./components/Chat";

const AppRoutes = () => (
  <Switch>
    {/* <Route exact path="/reportePlaniMaestro" component={ReportePM} /> */}
    <Route exact path="/expedienteNotas" component={ExpedienteNotas} />
    <Route exact path="/boletin" component={Boletin} />
    <Route exact path="/consultarNotas" component={ConsultarNotas} />
    <Route exact path="/reporteP" component={ReporteP} />
    <Route exact path="/subirTareas" component={SubirTareas} />
    <Route exact strict path="/cxc" component={CxC} />
    <Route exact strict path="/pago" component={Pago} />
    <Route exact strict path="/login" component={Login} />
    <Route exact strict path="/" component={Inicio} />
    <Route exact strict path="/chat" component={Chat} />
    <Route component={Pagina404} />
  </Switch>
);
export default AppRoutes;
